module.exports = __webpack_public_path__ + "img/shopee_9thb_0007.59430817.png";